export class UpdateActivityUserReportDtoDto {}
